<template>
    <div class="primary--text title mt-n1">
        {{title}}
    </div>
</template>

<script>
export default {
    props: ['title', 'length', 'btn_txt', 'btn_to']
}
</script>